import { normalizePhoneForSms } from './inviteContacts';

function unfoldVCardLines(text) {
  const raw = String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const lines = [];
  for (const line of raw.split('\n')) {
    if ((line.startsWith(' ') || line.startsWith('\t')) && lines.length) {
      lines[lines.length - 1] += line.slice(1);
    } else {
      lines.push(line);
    }
  }
  return lines;
}

function decodeVCardValue(value) {
  return String(value || '')
    .replace(/\\n/gi, '\n')
    .replace(/\\,/g, ',')
    .replace(/\\;/g, ';')
    .replace(/\\\\/g, '\\')
    .trim();
}

function parseNameFromN(value) {
  const parts = decodeVCardValue(value).split(';');
  const family = parts[0]?.trim();
  const given = parts[1]?.trim();
  if (given && family) return `${given} ${family}`.trim();
  return given || family || '';
}

function parseVCardBlock(blockLines) {
  let name = '';
  const phones = [];
  let email = null;

  for (const line of blockLines) {
    if (!line || line.toUpperCase() === 'BEGIN:VCARD' || line.toUpperCase() === 'END:VCARD') {
      continue;
    }

    const separatorIndex = line.indexOf(':');
    if (separatorIndex === -1) continue;

    const keyPart = line.slice(0, separatorIndex);
    const value = line.slice(separatorIndex + 1);
    const key = keyPart.split(';')[0].toUpperCase();

    if (key === 'FN' && !name) {
      name = decodeVCardValue(value);
    } else if (key === 'N' && !name) {
      name = parseNameFromN(value);
    } else if (key === 'TEL') {
      const phone = normalizePhoneForSms(decodeVCardValue(value));
      if (phone) phones.push(phone);
    } else if (key === 'EMAIL' && !email) {
      const parsed = decodeVCardValue(value).toLowerCase();
      if (parsed.includes('@')) email = parsed;
    }
  }

  return { name, phones, email };
}

export function parseVCardText(text) {
  const lines = unfoldVCardLines(text);
  const rows = [];
  let block = [];

  for (const line of lines) {
    if (line.toUpperCase() === 'BEGIN:VCARD') {
      block = [line];
      continue;
    }
    if (line.toUpperCase() === 'END:VCARD') {
      block.push(line);
      const parsed = parseVCardBlock(block);
      const displayName = parsed.name || 'Contact';
      for (const phone of parsed.phones) {
        rows.push({
          name: displayName,
          phone,
          email: parsed.email || undefined,
        });
      }
      block = [];
      continue;
    }
    if (block.length) block.push(line);
  }

  return rows;
}

export async function parseVCardFile(file) {
  const text = await file.text();
  return parseVCardText(text);
}
